var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStartyellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7681 0.547919C15.1433 -0.163227 16.1618 -0.163225 16.537 0.547921L20.5031 8.06503C20.6478 8.33928 20.9115 8.53089 21.217 8.58375L29.5918 10.0328C30.3841 10.1699 30.6988 11.1385 30.1384 11.7151L24.2148 17.81C23.9987 18.0324 23.898 18.3424 23.9421 18.6493L25.1519 27.062C25.2664 27.8578 24.4424 28.4565 23.7209 28.1017L16.0938 24.3514C15.8155 24.2146 15.4896 24.2146 15.2113 24.3514L7.58423 28.1017C6.86268 28.4565 6.03871 27.8578 6.15316 27.062L7.36299 18.6493C7.40712 18.3424 7.30639 18.0324 7.09028 17.81L1.16667 11.7151C0.60627 11.1385 0.921 10.1699 1.71329 10.0328L10.0881 8.58375C10.3936 8.53089 10.6573 8.33928 10.802 8.06503L14.7681 0.547919Z",
    fill: "#FFB457"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStartyellow);
export default __webpack_public_path__ + "static/media/rating_startyellow.b32e6693278abda824294b999dc9b48d.svg";
export { ForwardRef as ReactComponent };